import Cookies from 'js-cookie';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

import gameplay_1200 from '../img/hero/gameplay_1200.jpg';
import gameplay_1200_webp from '../img/hero/gameplay_1200.webp';
import bg_filter from '../img/gameplay/bg_fillter.png';

import navBG from '../img/nav/bg_menu_sp.jpg';

Fancybox.bind('[data-fancybox]', {
  Toolbar: {
    display: {
      left: [],
      middle: [],
      right: ['close'],
    },
  },
});

// if background video fails to play. replaces with image. Called from html inline onerror within video tag
function fallback(video) {
  const img = video.querySelector('img');
  if (img) {
    video.parentNode.replaceChild(img, video);
  }
}

// cookie set up when page loads. this will allow you to go directly to a FIGS page with index.html?lang="yourlangcode" and be able to have the correct language show up/////
//  will check for any name after a query string in the URL. Here using it to find the language if it's set.
const urlParam = name => {
  const results = new RegExp('[?&]' + name + '=([^&#]*)').exec(
    window.location.href,
  );
  if (results == null) {
    return null;
  }
  return decodeURI(results[1]) || 0;
};
//  this is how you use the above function, can put in any name that you need to find in a query string within the URL into the call.
const langQuery = urlParam('lang');
const langCookie = Cookies.get('lang');
const productsPage = document
  .querySelector('body')
  .classList.contains('products');

console.log(productsPage);
if (productsPage) {
  //  now checking to see if language in the query and cookie are set and, fixing any issues
  //  check to see if they are both there
  if (langQuery && langCookie) {
    //  if they are both there but different we need to reset the cookie to what the query is and then reload the page
    if (langQuery !== langCookie) {
      Cookies.set('lang', langQuery);
      // window.location.replace("index.html?lang=" + langQuery);
    }
    //  if query is set but not the cookie, then we need to set the cookie and again reload the page
  } else if (langQuery && !langCookie) {
    Cookies.set('lang', langQuery);
    //  window.location.replace("index.html?lang=" + langQuery);
    //  if neither is set, we set the cookie to english and leave the page alone.
  } else if (!langCookie && !langQuery) {
    //  CHANGE THIS TO SET STARTING COUNTRY
    Cookies.set('lang', 'en');
    //  if the query doesn't exist but the cookie does then set it.
  } else if (langQuery === null && langCookie) {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('lang', langCookie);
    window.location.search = urlParams;
  }
  //  there is no else as the final group of if cookie is set but not the query string the correct language would still be displayed.
}

//  checks to see if JS is enabled on the page. If it does, then no-js will be removed. This statement will allow css background images to be set.

document.documentElement.classList.remove('no-js');

//  replace <a> tag .jpg in media section with .webp files if webp is safe to use.

const isWebpAvailable = document.querySelector('html');
if (isWebpAvailable.classList.contains('webp')) {
  let singleSrc;
  let multilineSrc;
  document.querySelectorAll('[data-fancybox="media"]').forEach(elem => {
    multilineSrc = elem.dataset.srcset.replace(/jpg/g, 'webp').trim();
    singleSrc = elem.dataset.src.replace('jpg', 'webp');
    elem.dataset.srcset = multilineSrc;
    elem.dataset.src = singleSrc;
  });
}

const activeNav = document.querySelectorAll('.navigation__active');

activeNav.forEach(navItem => {
  navItem.addEventListener('click', e => {
    e.preventDefault();
  });
});

//  hiding part of nav or showing it. Otherwise see the buttons on the hamburger nav transition visibly on screen.
const setNavStyles = () => {
  const navigation = document.querySelector('.navigation__nav');
  const checkBox = document.querySelector('.navigation__checkbox');
  if (checkBox.checked) {
    checkBox.checked = false;
  }
  if (window.innerWidth >= 900) {
    navigation.classList.add('navigation__nav--open');
  } else {
    navigation.classList.remove('navigation__nav--open');
  }
};
window.addEventListener(
  'resize',
  () => {
    setNavStyles();
  },
  true,
);

setNavStyles();

const navigation = document.querySelector('.navigation__nav');
const checkBox = document.querySelector('.navigation__checkbox');
const navBtn = document.querySelector('.navigation__button');

navBtn.addEventListener('click', () => {
  if (checkBox.checked) {
    navigation.classList.remove('navigation__nav--open');
  } else {
    navigation.classList.add('navigation__nav--open');
  }
});

// home page character cards on click

let cards = document.querySelectorAll('.card');
const characterBtn = document.querySelectorAll('.checkCharacter');

if (!document.querySelector('.characterPage')) {
  Cookies.set('character', 'subaru');
}

cards = [...cards, ...characterBtn];

cards.forEach(card => {
  card.addEventListener('click', function (e) {
    e.preventDefault();
    if (card.contains(e.target)) {
      const character = card.dataset.character;
      console.log(character);
      Cookies.set('character', character);
      window.location.href = './characters.html';
    }
  });
});

// home page animate hero area

const videoTitleBoxes = document.querySelectorAll('.imagegroup__titleBox');
const animatedUp = document.querySelectorAll('.animate__up');
const characterCards = document.querySelectorAll('.card');
let observer2;

if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('add__transform');
          entry.target.classList.remove('animate__down');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2 },
  );

  videoTitleBoxes.forEach(titleBox => {
    observer.observe(titleBox);
  });

  observer2 = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('add__transform__opacity');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1 },
  );

  animatedUp.forEach(wrapper => {
    observer2.observe(wrapper);
  });

  const observer3 = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('add__rotate');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1 },
  );

  characterCards.forEach(wrapper => {
    observer3.observe(wrapper);
  });
}

// foldout animation on small screen
function gameplayAnimateUp() {
  const addAnimateUpToo = document.querySelectorAll('.foldout');
  addAnimateUpToo.forEach(elem => {
    if (window.innerWidth >= 900) {
      elem.classList.remove('animate__up');
    } else {
      elem.classList.add('animate__up');
      observer2.observe(elem);
    }
  });
}
gameplayAnimateUp();
window.addEventListener('resize', gameplayAnimateUp);
// window.addEventListener('scroll', function () {
//   if (document.querySelector('.home')) {
//     const button = document.querySelector('.btn__follow');
//     if (window.scrollY > 300) {
//       button.classList.add('add__transform__opacity');
//     } else {
//       button.classList.remove('add__transform__opacity');
//     }
//   }
// });

window.addEventListener('scroll', function () {
  const homeElement = document.querySelector('.hero__videos');
  const button = document.querySelector('.btn__follow');

  if (homeElement && button) {
    const homeRect = homeElement.getBoundingClientRect();

    // Check if the top of the `.home` element has moved beyond 300px from the top of the viewport
    if (homeRect.top < 300) {
      button.classList.add('add__transform__opacity');
    } else {
      button.classList.remove('add__transform__opacity');
    }
  }
});

// story page animate text

const storyText = document.querySelector('.story__text');
if (storyText) {
  storyText.classList.add('add__transform__opacity');
}

// hero gameplay area page animate text

const gameplayHeroImage = document.querySelector(
  '.hero__gameplay__screenshot__anchor',
);
if (gameplayHeroImage) {
  if (isWebpAvailable.classList.contains('webp')) {
    gameplayHeroImage.href = gameplay_1200_webp;
  } else {
    gameplayHeroImage.href = gameplay_1200;
  }
}

// cookie modal window
// check for cookie acceptance.
(() => {
  const cookiesAccepted = Cookies.get('accept__cookies');
  if (cookiesAccepted) {
    document.querySelector('.modal').classList.add('modal__hide');
  } else {
    document.querySelector('.modal').classList.remove('modal__hide');
  }
})();

const btnClickedModal = document.querySelector('.btn__clicked__modal');

btnClickedModal.addEventListener('click', () => {
  Cookies.set('accept__cookies', 'true', { expires: 30 });
  document.querySelector('.modal').classList.add('modal__hide');
});
